import { render, staticRenderFns } from "./vartext.vue?vue&type=template&id=a4a1cb84&"
import script from "./vartext.vue?vue&type=script&lang=js&"
export * from "./vartext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports